import { Component, Input, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhImage, VhQueryAutoWeb } from 'vhautowebdb';
import { NzMessageService } from 'ng-zorro-antd/message';
// import { EditNameComponent } from 'src/app/design-web/dialog/edit-name/edit-name.component';
// import { FunctionService  } from 'vhobjects-service';
// import { ChooseImageComponent, ManageLibraryComponent } from 'vhobjects-service';
import { EditNameComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';
import { ChooseImageComponent } from 'vhobjects-service';
import { ManageLibraryComponent } from 'vhobjects-service';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { LanguageService } from 'vhobjects-service/src/services';
@Component({
  selector: 'app-image-before-after-slider-admin',
  templateUrl: './image-before-after-slider-admin.component.html',
  styleUrls: ['./image-before-after-slider-admin.component.scss']
})

export class AtwImageBeforeAfterSliderAdmin {
  @Input() data: any; // dữ liệu của object từ block truyền vào gồm {_id, component, desktop_position, mobile_position, x, y, rows, cols, layerIndex}


  devices = [
    {
      value: 'desktop',
      label: 'may_tinh',
      width: 1920,
      height: 1080,
      display: false,
      icon: 'desktop'
    },
    {
      value: 'tablet_landscape',
      label: 'may_tinh_bang_ngang',
      width: 1920,
      height: 1080,
      display: false,
      icon: 'tablet'
    },
    {
      value: 'tablet_portrait',
      label: 'may_tinh_bang_doc',
      width: 1920,
      height: 1080,
      display: false,
      icon: 'tablet'
    },
    {
      value: 'mobile_landscape',
      label: 'dien_thoai_ngang',
      width: 1920,
      height: 1080,
      display: false,
      icon: 'mobile'
    },
    {
      value: 'mobile_portrait',
      label: 'dien_thoai_doc',
      width: 1920,
      height: 1080,
      display: false,
      icon: 'mobile'
    }
  ]
  loading: boolean = false;
  isShowConfirmPopup: boolean = false;
  path = '/images';
  deviceChoosed: string = 'desktop' // biến này để khi người dùng chọn upload ảnh ở thiết bị nào
  imageDeviceWidthMax: string = 'desktop' // biến này để lưu thiết bị có hình ảnh width lớn nhất, nếu chọn option dùng chung thì sẽ dùng biến này làm mặc định
  widthImageMax: number = 0;
  heightImageMax: number = 0;
  subproject = null;
  resolution = null;
  id_subproject;
  visible_config_tool;
  maxDeviceWidth: number = 0; // lưu width của thiết bị có width lớn nhất
  deviceWidthMax: string = 'desktop'; // lưu thiết bị có width lớn nhất
  compressWidth: number = 100;
  compressHeight: number = 100;

  /** Ảnh đang chọn để cấu hình */
  selectedImageToConfig: string = 'image__before';


  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private mess: NzMessageService,
    private vhImage: VhImage,
    private functionService: FunctionService,
    private matdialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: Object,
    private languageService: LanguageService,
  ) { }


  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.id_subproject = this.vhQueryAutoWeb.getlocalSubProject_Working()._id;
      this.subproject = this.vhQueryAutoWeb.getlocalSubProject(this.vhQueryAutoWeb.getlocalSubProject_Working()._id);
      this.resolution = this.subproject.resolution;

      this.devices.forEach(device => {
        if (this.subproject[device.value + '_template_display']) {
          device.display = true;

          if (this.resolution[device.value + '_width'] > this.maxDeviceWidth) {
            this.maxDeviceWidth = this.resolution[device.value + '_width']
            this.deviceWidthMax = device.value
          }
        }
      })
    }

    this.getWidthHeightImage();
  }






  /**
   * Cập nhật  vào database.
   */
  updateObject(value) {
    this.vhQueryAutoWeb.updateObject(this.data._id, value)
      .then((bool) => {
        // console.log('update data', bool);
      },
        (error) => {
          console.log('error', error);
        }
      );
  }




  /**
   * Click vào input #upload để mở hộp thoại chọn ảnh và gọi sự kiện onUpload
   */
  openUpload() {
    if (isPlatformBrowser(this.platformId)) {
      var inputVal = document.querySelector('#upload') as HTMLElement;
      inputVal.click();
    }
  }


  /**
  * no-compress': Không nén ảnh sau khi tải lên
  'compress-screen': Nén ảnh sau khi tải lên, nén ảnh theo tỉ lệ màn hình của mỗi thiết bị
  'compress-frame': Nén ảnh sau khi tải lên, nén ảnh theo tỉ lệ màn hình của mỗi khung hình thiết bị
  */
  onUpload(e) {
    const file = e.target.files[0];
    const input = e.target as HTMLInputElement;
    // dùng chung -> nén theo khung ảnh -> lấy hình ảnh có width lớn nhất
    // dùng chung -> nén theo màn hình -> lấy màn hình có width lớn nhất 

    // dùng riêng -> nén theo khung ảnh -> lấy hình ảnh hiện tại
    // dùng riêng -> nén theo màn hình -> lấy hình ảnh hiện tại
    let deviceCurrent = 'desktop'
    let compress_type = this.data.setups.upload_image.compress_type // vì hàm không nhận compress_type == 'custom' nên phải dùng biến này để truyền lên
    // dùng chung
    if (this.data.setups.upload_image.display == 'shared') {
      // nén theo khung ảnh
      if (this.data.setups.upload_image.compress_type == 'compress-frame') {
        deviceCurrent = this.imageDeviceWidthMax
      }
      // nén theo màn hình
      else if (this.data.setups.upload_image.compress_type == 'compress-screen') {
        deviceCurrent = this.deviceWidthMax
      }
    } else {
      deviceCurrent = this.deviceChoosed
    }

    let resolution = {}
    switch (this.data.setups.upload_image.compress_type) {
      case 'compress-screen':
        resolution = {
          width: this.resolution[deviceCurrent + '_width'],
          height: 0
        }
        break;
      case 'compress-frame':
        resolution = {
          width: this.devices.find(device => device.value == deviceCurrent).width,
          height: this.devices.find(device => device.value == deviceCurrent).height
        }
        break;
      case 'custom':
        resolution = {
          width: +this.compressWidth,
          height: +this.compressHeight
        }
        compress_type = 'compress-frame'
        break;
    }
    // console.log('resolution', resolution);
    if (file) {
      this.vhImage.getImageFromDesktop_Autoweb(file, 'images/design/objects', {
        compress_type: compress_type,
        resolution: resolution
      })
        .then((res: any) => {
          // console.log(res);
          if (res.vcode != 0) {
            this.mess.error(`${this.languageService.translate('tai_anh_that_bai_ly_do')}: ${res.msg}`);
            return
          }
          // nếu là dùng chung ảnh thì lưu ảnh vào các thiết bị
          // nếu không thì lưu ảnh vào thiết bị đang chọn
          if (this.data.setups.upload_image.display == 'shared') {
            this.devices.forEach(device => {
              this.data.staticdata[this.selectedImageToConfig][device.value + '_img'] = res.data
            })
          } else {
            this.data.staticdata[this.selectedImageToConfig][this.deviceChoosed + '_img'] = res.data
          }

          this.updateObject({ staticdata: this.data.staticdata });
          this.functionService.createMessage('success', 'hinh_anh_da_duoc_tai_thanh_cong');
        })
    }

    // Đặt lại giá trị của trường tệp để kích hoạt sự kiện change lần sau
    input.value = '';
  }


  /**
   * Hàm xử lý lấy ảnh ở thư viện
   */
  openLibrary() {
    const dialogRef = this.matdialog.open(ManageLibraryComponent, {
      width: '85%',
      maxWidth: '100%',
      data: {
        startPath: this.path ? this.path : '/images/design/objects',
        scopeData: '/images',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data.href) {
        // nếu là dùng chung ảnh thì lưu ảnh vào các thiết bị
        // nếu không thì lưu ảnh vào thiết bị đang chọn
        if (this.data.setups.upload_image.display == 'shared') {
          this.devices.forEach(device => {
            this.data.staticdata[this.selectedImageToConfig][device.value + '_img'] = data.href
          })
        }
        else {
          this.data.staticdata[this.selectedImageToConfig][this.deviceChoosed + '_img'] = data.href
        }

        this.updateObject({ staticdata: this.data.staticdata });
        this.functionService.createMessage('success', 'hinh_anh_da_duoc_tai_thanh_cong');
      }
    });
  }


  handleChangeImage(device?: string) {
    this.deviceChoosed = device
    switch (this.data.setups.upload_image.source) {
      case 'device':
        this.openUpload()
        break;
      case 'library':
        this.openLibrary()
        break
      case 'free_img':
        this.openDialogFreeImage()
        break;
    }
  }


  /**
   * Hàm mở ra hộp thoại chọn free image
   */
  openDialogFreeImage() {
    this.visible_config_tool = false;
    const dialogRef = this.matdialog.open(ChooseImageComponent, {
      width: '80vw',
      height: '90vh',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // nếu là dùng chung ảnh thì lưu ảnh vào các thiết bị
        // nếu không thì lưu ảnh vào thiết bị đang chọn
        if (this.data.setups.upload_image.display == 'shared') {
          this.devices.forEach(device => {
            this.data.staticdata[this.selectedImageToConfig][device.value + '_img'] = result
          })
        }
        else {
          this.data.staticdata[this.selectedImageToConfig][this.deviceChoosed + '_img'] = result
        }
        this.updateObject({ staticdata: this.data.staticdata });
        this.functionService.createMessage('success', 'hinh_anh_da_duoc_tai_thanh_cong');
      }
      this.visible_config_tool = true;
    });
  }


  changeUrl() {
    // nếu là dùng chung ảnh thì lưu ảnh vào các thiết bị
    // nếu không thì lưu ảnh vào thiết bị đang chọn
    if (this.data.setups.upload_image.display == 'shared') {
      this.devices.forEach(device => {
        this.data.staticdata[this.selectedImageToConfig][device.value + '_img'] = this.data.staticdata[this.selectedImageToConfig][this.imageDeviceWidthMax + '_img']
      })
    }
    else {
      this.data.staticdata[this.selectedImageToConfig][this.deviceChoosed + '_img'] = this.data.staticdata[this.selectedImageToConfig][this.imageDeviceWidthMax + '_img']
    }
    this.functionService.createMessage('success', 'hinh_anh_da_duoc_tai_thanh_cong');
    this.updateObject({ staticdata: this.data.staticdata });
  }



  /**
   *  lấy width height của ảnh của từng thiết bị
      lấy width height của ảnh của thiết bị có width lớn nhất
   */
  getWidthHeightImage() {
    this.devices.forEach(device => {
      device.width = parseFloat(Number(this.data[device.value + '_class'][this.data.resize_field]['width'].replace('px', '')).toFixed(0))
      device.height = parseFloat(Number(this.data[device.value + '_class'][this.data.resize_field]['height'].replace('px', '')).toFixed(0))
      if (this.widthImageMax < device.width) {
        this.widthImageMax = device.width
        this.heightImageMax = device.height
        this.imageDeviceWidthMax = device.value
      }
    })
  }


  /** 
   * Lấy hình ảnh từ url đẩy lên server với kích thước hình ko thay đổi
   * */
  handleOkConfirm() {
    // dùng chung -> nén theo khung ảnh -> lấy hình ảnh có width lớn nhất
    // dùng chung -> nén theo màn hình -> lấy màn hình có width lớn nhất 

    // dùng riêng -> nén theo khung ảnh -> lấy hình ảnh hiện tại
    // dùng riêng -> nén theo màn hình -> lấy hình ảnh hiện tại
    let deviceCurrent = 'desktop'
    let compress_type = this.data.setups.upload_image.compress_type // vì hàm không nhận compress_type == 'custom' nên phải dùng biến này để truyền lên
    // dùng chung
    if (this.data.setups.upload_image.display == 'shared') {
      // nén theo khung ảnh
      if (this.data.setups.upload_image.compress_type == 'compress-frame') {
        deviceCurrent = this.imageDeviceWidthMax
      }
      // nén theo màn hình
      else if (this.data.setups.upload_image.compress_type == 'compress-screen') {
        deviceCurrent = this.deviceWidthMax
      }
    } else {
      deviceCurrent = this.deviceChoosed
    }

    let resolution = {}
    switch (this.data.setups.upload_image.compress_type) {
      case 'compress-screen':
        resolution = {
          width: this.resolution[deviceCurrent + '_width'],
          height: 0
        }
        break;
      case 'compress-frame':
        resolution = {
          width: this.devices.find(device => device.value == deviceCurrent).width,
          height: this.devices.find(device => device.value == deviceCurrent).height
        }
        break;
      case 'custom':
        resolution = {
          width: +this.compressWidth,
          height: +this.compressHeight
        }
        compress_type = 'compress-frame'
        break;
    }
    // console.log('resolution', resolution);
    this.vhImage.getImageFromURL_Autoweb(this.data.staticdata[this.selectedImageToConfig][deviceCurrent + '_img'], "images/design/objects", {
      compress_type: compress_type,
      resolution: resolution
    })
      .then((rsp: any) => {
        if (rsp.vcode != 0) {
          this.mess.error('Tải ảnh thất bại! Lý do: ' + rsp.msg)
          return;
        }
        // nếu là dùng chung ảnh thì lưu ảnh vào các thiết bị
        // nếu không thì lưu ảnh vào thiết bị đang chọn
        if (this.data.setups.upload_image.display == 'shared') {
          this.devices.forEach(device => {
            this.data.staticdata[this.selectedImageToConfig][device.value + '_img'] = rsp.data
          })
        } else {
          this.data.staticdata[this.selectedImageToConfig][this.deviceChoosed + '_img'] = rsp.data
        }
        this.updateObject({ staticdata: this.data.staticdata });
        this.functionService.createMessage('success', 'hinh_anh_da_duoc_tai_thanh_cong');
        this.isShowConfirmPopup = false;
      })
  }


  deleteImage(device?) {
    if (this.data.setups.upload_image.display == 'shared') {
      this.devices.forEach(item => {
        this.data.staticdata[this.selectedImageToConfig][item.value + '_img'] = ''
      })
    }
    else {
      this.data.staticdata[this.selectedImageToConfig][device + '_img'] = ''
    }
    this.updateObject({ staticdata: this.data.staticdata });
  }


  handleCancelConfirm() {
    this.isShowConfirmPopup = false;
  }


  /**
   * Hàm mở ra hộp thoại chỉnh sửa tên và update data
   * @param object 
   */
  editNameObject(object: any) {
    this.matdialog
      .open(EditNameComponent, {
        width: '20%',
        data: object.name || this.data.name,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.data.name = result;
          this.updateObject({ name: this.data.name });
        }
      });
  }

}
